"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanPurpose = void 0;
var LoanPurpose;
(function (LoanPurpose) {
    LoanPurpose["REFINANCE"] = "REFINANCE";
    LoanPurpose["MONTHLY"] = "MONTHLY";
    LoanPurpose["TERMS"] = "TERMS";
    LoanPurpose["CASHOUT"] = "CASHOUT";
    LoanPurpose["CONSOLIDATE"] = "CONSOLIDATE";
    LoanPurpose["CONSTRUCTION"] = "CONSTRUCTION";
    LoanPurpose["PURCHASE"] = "PURCHASE";
    LoanPurpose["HELOC"] = "HELOC";
    LoanPurpose["OVERDRAFT_PROTECTION"] = "OVERDRAFT_PROTECTION";
    LoanPurpose["PERSONAL_LOAN"] = "PERSONAL_LOAN";
    LoanPurpose["AUTO_LOAN"] = "AUTO_LOAN";
    LoanPurpose["REVERSE"] = "REVERSE";
})(LoanPurpose = exports.LoanPurpose || (exports.LoanPurpose = {}));
